import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { isEmpty } from 'lodash'
import { useRouter } from 'next/router'

import Multiparking from 'components/Organisms/Multiparking'
import SEO from 'seo/page'
import { Full as Template } from 'components/Templates'
import { hideModal } from 'components/Atoms/Modal/actions'
import { showBasicModal } from 'helpers/modal'
import { useTranslation, Trans } from 'i18n-web/i18next'
import Text from 'components/Atoms/Text'

const Screen = props => {
  const { application, user, isLoading, isClosed, downloadAppLink } = props

  const dispatch = useDispatch()
  const router = useRouter()
  const { t } = useTranslation()

  useEffect(() => {
    if (isClosed) {
      // Prefetch home for a faster page transition
      router.prefetch('/')
      dispatch(
        showBasicModal({
          title: t('common.title.sorry'),
          description: (
            <Trans i18nKey="payBySignage.error.unavailable">
              <Text
                as="a"
                target="_blank"
                className="medium link"
                href={downloadAppLink}></Text>
            </Trans>
          ),
          preventClose: true,
          actionButtons: {
            singleButtonOnClick: () => {
              router.push('/')
              dispatch(hideModal())
            },
            singleButtonText: t('common.button.goToHomepage'),
          },
        })
      )
    }
  }, [isClosed])

  return (
    <Template
      application={application}
      hideLanguageSelector={false}
      hideMenu={isEmpty(user) || user?.isGuest}
      onLogoutRedirection={router.asPath}
      spacingTop>
      <SEO
        title={t('common.seo.title')}
        description={t('common.seo.description')}
      />
      <Multiparking {...props} isLoading={isLoading} />
    </Template>
  )
}

Screen.propTypes = {
  application: PropTypes.string,
  downloadAppLink: PropTypes.string,
  isLoading: PropTypes.bool,
  isClosed: PropTypes.bool,
  user: PropTypes.object,
}

export default Screen
